import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3a8382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new_resource" }
const _hoisted_2 = {
  key: 0,
  class: "resource_black"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black_title" }, "选择资源包类型", -1))
const _hoisted_4 = { class: "black_one black_content mt" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "resource_black" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black_title" }, "选择资源配置", -1))
const _hoisted_8 = { class: "black_content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content_square_nav" }
const _hoisted_12 = { class: "content_square_con" }
const _hoisted_13 = { class: "content_square_info" }
const _hoisted_14 = { class: "content_square_icon" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "resource_black" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black_title" }, "资源时长", -1))
const _hoisted_18 = { class: "black_content mt" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "content_austral_box" }
const _hoisted_21 = { class: "content_austral_black" }
const _hoisted_22 = { class: "content_austral_black" }
const _hoisted_23 = { class: "resource_bottom" }
const _hoisted_24 = { class: "bottom_info" }
const _hoisted_25 = { class: "bottom_black" }
const _hoisted_26 = { class: "pt" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pb" }, "购买前容量", -1))
const _hoisted_28 = { class: "bottom_black" }
const _hoisted_29 = { class: "pt" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pb" }, "已使用容量", -1))
const _hoisted_31 = { class: "bottom_black" }
const _hoisted_32 = { class: "pt" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pb" }, "购买后容量", -1))
const _hoisted_34 = { class: "bottom_info" }
const _hoisted_35 = { class: "bottom_black" }
const _hoisted_36 = { class: "py" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pb" }, "支付金额", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "容量套餐说明", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "resource_explain"
}
const _hoisted_41 = { class: "explain_box" }
const _hoisted_42 = { class: "explain_con" }
const _hoisted_43 = { class: "explain_title" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "容量套餐说明", -1))
const _hoisted_45 = { class: "explain" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb" }, "容量套餐说明", -1))
const _hoisted_47 = { class: "explain_qusesion" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "问", -1))
const _hoisted_49 = { class: "explain_anyser mt" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "答", -1))
const _hoisted_51 = { class: "mt" }
const _hoisted_52 = { class: "explain_list mt" }
const _hoisted_53 = { class: "list_row" }
const _hoisted_54 = { class: "list_row" }
const _hoisted_55 = { class: "mt" }
const _hoisted_56 = { class: "explain_list mt" }
const _hoisted_57 = { class: "list_row" }

import { computed, reactive, ref, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import http from '@/api/resource';
import type { IPkgData, IResourceList, ITerm } from './type';
import { message } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewResourceBuy',
  setup(__props) {

_useCssVars(_ctx => ({
  "07e75a04": (_unref(explainWidth))
}))

const RESOURCETYPE = {
  MEDIA: 4, // 媒体库容量
  LIVENUM: 12, // 直播间数量
};
const router = useRouter();
const route = useRoute();
const pkgType = ref<IPkgData[]>([]); //资源包数据
const packageIndex = ref();

watch(packageIndex, (newVal, oldVal) => {
  if (oldVal === RESOURCETYPE.MEDIA && newVal !== oldVal) {
    showSetMeal.value && clickOpenClose();
  }
});

const clickTypeTabs = (item: IPkgData) => {
  packageIndex.value = item.package_index;
  getPackIndex();
};
const getPackTypes = () => {
  http.getPackType().then((res) => {
    pkgType.value = [...res.data.data];
    packageIndex.value = pkgType.value[0].package_index;
    getPackIndex();
  });
};
getPackTypes();

const newResourceMold = ref<IResourceList[]>([]);
const pageList = (index: number) => {
  const list = [
    {
      background: require('@/assets/resource/resource_pkg1.png'),
      icon: require('@/assets/resource/resource_mask1.png'),
      color: '#12578B',
    },
    {
      background: require('@/assets/resource/resource_pkg2.png'),
      icon: require('@/assets/resource/resource_mask2.png'),
      color: '#39489D',
    },
    {
      background: require('@/assets/resource/resource_pkg3.png'),
      icon: require('@/assets/resource/resource_mask3.png'),
      color: '#6A4636',
    },
    {
      background: require('@/assets/resource/resource_pkg4.png'),
      icon: require('@/assets/resource/resource_mask4.png'),
      color: '#A36F40',
    },
  ];
  if (index < 4) {
    return list[index];
  } else {
    return list[index % 4];
  }
};
const resourcePkgKey = ref();
const clickPkgTabs = (item: IResourceList) => {
  resourcePkgKey.value = item.id;
  payInfo();
};

const newResourceDuration = ref<ITerm[]>([]);
const durationList = [
  { title: '与版本有效期一致', subtitle: '版本到期时间' },
  { title: '购买天数', subtitle: '预计到期时间' },
];
const getPackIndex = () => {
  let data = {
    package_index: packageIndex.value,
  };
  http.getPackByIndex({ params: data }).then((res) => {
    const resData = res.data.data;
    resData.forEach((e: any, index: number) => {
      e.background = pageList(index).background;
      e.icon = pageList(index).icon;
      e.color = pageList(index).color;
    });
    newResourceMold.value = resData;
    resourcePkgKey.value = newResourceMold.value[0].id;
    newResourceDuration.value = newResourceMold.value[0].term.reverse();
    newResourceDuration.value.forEach((e, index) => {
      e.subtitle = durationList[index].subtitle;
      e.title = durationList[index].title;
    });
    resourceTimeKey.value = newResourceDuration.value[1].term_type;
    payInfo();
  });
};

const resourceTimeKey = ref();
const clickTimeTabs = (item: ITerm) => {
  resourceTimeKey.value = item.term_type;
  payInfo();
};
const paymentAmount = ref();
const capacity = reactive({ before: 0, used: 0, after: 0, unit: '' });
const payInfo = () => {
  const data = {
    id: resourcePkgKey.value,
    term_type: resourceTimeKey.value,
    count: 1,
  };
  http.payPackageInfo({ params: data }).then((res) => {
    paymentAmount.value = res.data.data.amount;
    capacity.before = res.data.data.store_total;
    capacity.used = res.data.data.store_used;
    capacity.after = res.data.data.store_total_pay_by;
    capacity.unit = res.data.data.unit;
  });
};
const explainList = [
  {
    question: '容量扩展套餐是什么',
    antser:
      '容量扩展套餐是提供的素材存储容量扩展服务，当您的素材存储容量不足时，可以通过购买容量套餐进行容量扩充，存储更多文件。',
  },
  {
    question: '容量套餐的有效期如何计算',
    antser: '当您成功购买容量套餐后，选择对应的有效时间，扩展容量立即生效，容量套餐的有效期为一年，有效期按照自然年进行计算。',
    p1: '当购买一个容量套餐时，如：您于2022年11月21日购买一年的100GB容量套餐',
    arr1: { title: ['开始时间', '结束时间', '未过期容量'], content: ['2022年11月21日', '2023年11月20日', '100GB'] },
    p2: '当购买多个容量套餐时，容量进行叠加，如：您于2022年11月21日购买100GB容量套餐，2022年11月26日再购买500GB容量套餐。',
    arr2: {
      title: ['开始时间', '结束时间', '未过期容量'],
      content: {
        time1: ['2022年11月21日', '2022年11月25日', '100GB'],
        time2: ['2022年11月26日', '2023年11月20日', '600GB'],
        time3: ['2023年11月20日', '2023年11月25日', '500GB'],
      },
    },
  },
  {
    question: '容量套餐到期后，容量该如何处理',
    antser: '如您已购买的容量套餐到期，未进行续费，到期后所购买的容量将被收回。',
    p1: '当收回容量时您素材库中已存储的文件，小于当前可使用容量，则文件将不受任何影响，仍可正常使用。',
    p2: '当收回容量时您素材库中已存储的文件，超出或等于当前可使用容量，超出可使用容量部分的文件不会被删除，但你将无法向素材库中存储文件，即上传、引用等功能暂不可用，其他功能不受影响。',
  },
];

const showSetMeal = ref(true);
const clickOpenClose = () => {
  showSetMeal.value = !showSetMeal.value;
};

const explainWidth = computed(() => (showSetMeal.value ? '400px' : '0px'));

const toNext = () => {
  message.destroy();
  router.push({
    name: 'WalletPay',
    params: {
      goods_id: '0-' + resourcePkgKey.value,
    },
    query: {
      id: resourcePkgKey.value,
      term_type: resourceTimeKey.value,
      count: 1,
      start_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (pkgType.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pkgType.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["one_square", { actived: packageIndex.value === item.package_index }]),
                key: item.package_index,
                onClick: ($event: any) => (clickTypeTabs(item))
              }, _toDisplayString(item.title), 11, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newResourceMold.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["content_square mt", { actived: resourcePkgKey.value === item.id }]),
            key: item.id,
            onClick: ($event: any) => (clickPkgTabs(item))
          }, [
            _createElementVNode("img", {
              src: item.background,
              class: "img"
            }, null, 8, _hoisted_10),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: item.color })
                  }, _toDisplayString(item.name), 5),
                  _createElementVNode("div", {
                    class: "square_info_black",
                    style: _normalizeStyle({ color: item.color })
                  }, _toDisplayString(item.money_unit), 5)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: item.icon
                  }, null, 8, _hoisted_15)
                ])
              ])
            ])
          ], 10, _hoisted_9))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newResourceDuration.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["content_austral", { actived: resourceTimeKey.value === item.term_type }]),
            key: item.term_type,
            onClick: ($event: any) => (clickTimeTabs(item))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(item.title), 1),
                _withDirectives(_createElementVNode("p", { style: {"font-size":"16px"} }, _toDisplayString(item.term_name), 513), [
                  [_vShow, item.term_type === 5]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", null, _toDisplayString(item.subtitle), 1),
                _createElementVNode("p", null, _toDisplayString(item.term_end), 1)
              ])
            ])
          ], 10, _hoisted_19))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", _hoisted_26, _toDisplayString(capacity.before) + _toDisplayString(capacity.unit), 1),
          _hoisted_27
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("p", _hoisted_29, _toDisplayString(capacity.used) + _toDisplayString(capacity.unit), 1),
          _hoisted_30
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("p", _hoisted_32, _toDisplayString(capacity.after) + _toDisplayString(capacity.unit), 1),
          _hoisted_33
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("p", _hoisted_36, "¥" + _toDisplayString(paymentAmount.value), 1),
          _hoisted_37
        ]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: toNext
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交订单")
          ]),
          _: 1
        })
      ])
    ]),
    (RESOURCETYPE.MEDIA === packageIndex.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "explain_title explain_btn",
          onClick: clickOpenClose
        }, _hoisted_39))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "explain_slide" }, {
      default: _withCtx(() => [
        (showSetMeal.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", {
                      class: "cu",
                      onClick: clickOpenClose
                    }, [
                      _createVNode(_unref(CloseOutlined))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(explainList, (item) => {
                      return _createElementVNode("div", {
                        class: "mb",
                        key: item.question
                      }, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createTextVNode(" " + _toDisplayString(item.question), 1)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(item.antser), 1),
                            _createElementVNode("div", _hoisted_51, _toDisplayString(item.p1), 1),
                            _withDirectives(_createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr1?.title, (i, j) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "list_cell",
                                    key: j
                                  }, _toDisplayString(i), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr1?.content, (i, j) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "list_cell",
                                    key: j
                                  }, _toDisplayString(i), 1))
                                }), 128))
                              ])
                            ], 512), [
                              [_vShow, item.arr1]
                            ]),
                            _createElementVNode("div", _hoisted_55, _toDisplayString(item.p2), 1),
                            _withDirectives(_createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr2?.title, (i, j) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "list_cell",
                                    key: j
                                  }, _toDisplayString(i), 1))
                                }), 128))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr2?.content, (i, j) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "list_row",
                                  key: j
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i, (m, n) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "list_cell",
                                      key: n
                                    }, _toDisplayString(m), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ], 512), [
                              [_vShow, item.arr2]
                            ])
                          ])
                        ])
                      ])
                    }), 64))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})